import type { ComponentTheme } from '../types/component-theme';

import { ThemeVariants } from './constants/theme-variants';

export default {
    slots: {
        root: 'flex gap-0.5 rounded-[6.188rem] border-[0.063rem] p-1',
        option:
            'group relative flex flex-1 shrink-0 min-w-9.5 h-9.5 items-center justify-center border-[0.063rem] ' +
            'border-transparent bg-transparent! px-1.5 shadow-none! transition-[color,border-color,opacity] ' +
            'duration-[0.25s,0.25s,0.2s] ease-[cubic-bezier(0.25,0.8,0.25,1),cubic-bezier(0.25,0.8,0.25,1),ease]',
        indicator:
            'absolute inset-0 rounded-[inherit] border-[0.063rem] ' +
            'shadow-[inset_0.125rem_0.125rem_0.375rem_rgba(0,0,0,0.25)]',
        content:
            'relative z-1 flex items-center gap-1.5 whitespace-nowrap px-3.5 transition-[color] duration-200 ' +
            'ease-out',
        label: 'relative z-1 text-[0.75rem] font-semibold leading-none',
        icon: 'relative z-1 shrink-0'
    },
    variants: {
        theme: {
            [ThemeVariants.Dark]: {
                root: 'border-(--white-alpha-08) bg-(image:--surface-dark-pill-bg) shadow-(--surface-dark-pill-shadow)',
                option: 'text-(--white-alpha-35)!',
                indicator: 'border-(--white-alpha-10) bg-(--white-alpha-08)'
            },
            [ThemeVariants.Light]: {
                root:
                    'border-[rgba(148,163,184,0.18)] ' +
                    'bg-[linear-gradient(180deg,var(--white-alpha-96)_0%,rgba(241,245,249,0.92)_100%)] ' +
                    'shadow-[0_0.375rem_1rem_rgba(148,163,184,0.16),inset_0_0.063rem_0_rgba(255,255,255,0.9)]',
                option: 'text-[rgba(71,85,105,0.55)]!',
                indicator:
                    'border-[rgba(148,163,184,0.28)] ' +
                    'bg-[linear-gradient(180deg,rgba(226,232,240,0.96)_0%,rgba(203,213,225,0.92)_100%)] ' +
                    'shadow-[inset_0_0.063rem_0_rgba(255,255,255,0.9)]'
            }
        },
        disabled: {
            true: {
                root: 'opacity-[0.55] saturate-[0.7]',
                option: 'cursor-not-allowed! pointer-events-none!'
            },
            false: {
                option:
                    'focus-visible:outline-none! ' +
                    'focus-visible:shadow-[0_0_0_0.125rem_rgba(44,48,64,0.5),0_0_0_0.25rem_rgba(148,163,184,0.4)]!'
            }
        },
        active: {
            true: {
                option: 'cursor-default!'
            },
            false: {
                option: 'cursor-pointer'
            }
        },
        stackOnMobile: {
            true: {
                root: 'w-full flex-col desk:w-auto desk:flex-row max-desk:rounded-2xl!',
                option: 'rounded-2xl desk:rounded-[6.188rem]'
            },
            false: {
                option: 'rounded-[6.188rem]'
            }
        }
    },
    compoundVariants: [
        {
            theme: ThemeVariants.Dark,
            active: true,
            class: {
                content: 'text-(--white-alpha-92)!'
            }
        },
        {
            theme: ThemeVariants.Dark,
            active: false,
            class: {
                option: 'hover:text-[rgba(255,255,255,0.72)]! active:text-(--white-alpha-96)!'
            }
        },
        {
            theme: ThemeVariants.Light,
            active: true,
            class: {
                content: 'text-[rgba(15,23,42,0.92)]!'
            }
        },
        {
            theme: ThemeVariants.Light,
            active: false,
            class: {
                option: 'hover:text-[rgba(15,23,42,0.8)]! active:text-[rgba(15,23,42,0.95)]!'
            }
        }
    ]
} satisfies ComponentTheme;
